<div class="radio" (click)="toggleRadio()" [attr.data-test]="ppId">
  <div
    class="radio__inputBox"
    [ngClass]="class"
    [class.radio--blue--checked]="ppStyle === 'blue' && ppChecked && !ppDisabled"
    >
    @if (ppChecked) {
      <div
        class="radioCircle"
        [class.radioCircle--disabled]="ppChecked && ppDisabled"
      ></div>
    }
  </div>

  <div class="radio__label">
    <ng-content></ng-content>
  </div>
</div>
